import { motion } from "framer-motion";

/**
 * Shared animated section title used across Skills, Experience,
 * Projects, Education and Contact. Keeps the fade/slide-in
 * animation consistent without repeating it in every feature.
 */
const SectionHeading = ({ children }) => (
  <motion.h2
    initial={{ opacity: 0, y: -30 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
    viewport={{ once: true }}
    className="text-slate-100 font-bold text-2xl md:text-4xl text-center"
  >
    {children}
  </motion.h2>
);

export default SectionHeading;
